// @ts-nocheck
import React, { useEffect } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

function BiddingAgreementVerification() {
  // Destructuring the context provided by the parent component
  const { activeStep, setActiveStep } = useOutletContext();

  useEffect(() => {
    if (activeStep < 1) {
      setActiveStep(1); // Set activeStep to 1 if it is less than 1
    }
  }, [activeStep, setActiveStep]);

  return ( <Outlet />
  );
}

export default BiddingAgreementVerification;
